import React from "react";
import Icon from "../../../components/AppIcon";

const DistributionDetailModal = ({ distribution, onClose }) => {
  if (!distribution) return null;

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return new Intl.DateTimeFormat("en-GB", {
 day: "2-digit",
      month: "short",
      year: "numeric",
    }).format(date);
  };

  const formatAmount = (amount) => {
    return new Intl.NumberFormat("en-GB", {
      style: "currency",
      currency: "GBP",
  }).format(amount);
  };

  const getDistributionTypeLabel = (type) => {
    const types = {
      Equal: "Equal Split",
  ByJobRole: "By Job Role",
      ByJobRoleScore: "By Job Role Score",
ByDepartment: "By Department",
      ByHoursAndJobRole: "By Hours & Job Role",
    };
    return types[type] || type;
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div
        className="modal-content modal-xl"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="modal-header">
          <div>
            <h2 className="modal-title">Distribution Details</h2>
        <p className="text-muted-foreground text-sm">
    Period: {formatDate(distribution.periodStart)} -{" "}
              {formatDate(distribution.periodEnd)}
         </p>
          </div>
 <button
         onClick={onClose}
            className="btn btn-ghost btn-sm"
            aria-label="Close"
  >
<Icon name="X" size={20} />
          </button>
     </div>

        <div className="modal-body space-y-6">
          {/* Summary Section */}
  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
<div className="card p-4">
    <div className="flex items-center gap-3">
         <div className="w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center">
     <Icon name="PoundSterling" size={20} className="text-primary" />
   </div>
 <div>
         <p className="text-sm text-muted-foreground">Total Amount</p>
      <p className="text-lg font-bold text-primary">
           {formatAmount(distribution.totalAmount)}
         </p>
      </div>
        </div>
 </div>

  <div className="card p-4">
           <div className="flex items-center gap-3">
           <div className="w-10 h-10 rounded-full bg-accent/10 flex items-center justify-center">
         <Icon name="Users" size={20} className="text-accent" />
          </div>
          <div>
                  <p className="text-sm text-muted-foreground">Employees</p>
        <p className="text-lg font-bold">{distribution.employeeCount}</p>
  </div>
   </div>
     </div>

       <div className="card p-4">
              <div className="flex items-center gap-3">
     <div className="w-10 h-10 rounded-full bg-success/10 flex items-center justify-center">
     <Icon name="MapPin" size={20} className="text-success" />
           </div>
                <div>
               <p className="text-sm text-muted-foreground">Location</p>
             <p className="text-lg font-semibold truncate">
    {distribution.locationName}
    </p>
                </div>
          </div>
 </div>

   <div className="card p-4">
              <div className="flex items-center gap-3">
        <div className="w-10 h-10 rounded-full bg-secondary/10 flex items-center justify-center">
          <Icon name="Calendar" size={20} className="text-secondary" />
        </div>
           <div>
      <p className="text-sm text-muted-foreground">Distributed</p>
<p className="text-sm font-semibold">
  {formatDate(distribution.distributedOn)}
      </p>
                </div>
      </div>
         </div>
          </div>

          {/* Distribution Info */}
       <div className="card p-4">
            <div className="flex items-start gap-3">
       <Icon name="Info" size={20} className="text-muted-foreground mt-0.5" />
   <div className="space-y-2 flex-1">
    <div className="flex items-center justify-between">
       <span className="text-sm text-muted-foreground">Approved by:</span>
            <span className="font-medium">{distribution.approvedBy}</span>
        </div>
      <div className="flex items-center justify-between">
       <span className="text-sm text-muted-foreground">Distributed by:</span>
   <span className="font-medium">{distribution.distributedBy}</span>
    </div>
                <div className="flex items-center justify-between">
             <span className="text-sm text-muted-foreground">Status:</span>
       <span className="badge badge-success">{distribution.status}</span>
     </div>
  {distribution.hasManualOverride && (
      <div className="alert alert-warning mt-3">
        <Icon name="AlertCircle" size={16} />
          <p className="text-sm">
 This distribution contains manual adjustments to calculated amounts
 </p>
        </div>
 )}
              </div>
  </div>
          </div>

          {/* Distribution Rule */}
          {distribution.rule && (
          <div className="card">
              <div className="card-header">
              <h3 className="card-title">Distribution Rule</h3>
              </div>
         <div className="card-body space-y-4">
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
         <div>
                    <p className="text-sm text-muted-foreground">Rule Name</p>
            <p className="font-semibold">{distribution.rule.name}</p>
          </div>
<div>
         <p className="text-sm text-muted-foreground">Distribution Method</p>
    <p className="font-semibold">
       {getDistributionTypeLabel(distribution.rule.type)}
      </p>
      </div>
      </div>

        {distribution.rule.description && (
            <div>
                <p className="text-sm text-muted-foreground">Description</p>
     <p className="text-sm">{distribution.rule.description}</p>
         </div>
    )}

           {/* Rule Allocations */}
  {distribution.rule.allocations && distribution.rule.allocations.length > 0 && (
      <div>
        <p className="text-sm font-semibold mb-2">Rule Allocations</p>
     <div className="space-y-2">
           {distribution.rule.allocations.map((allocation, index) => (
      <div
 key={index}
   className="flex items-center justify-between p-2 bg-muted/50 rounded"
  >
            <span className="text-sm">
           {allocation.jobRoleName || allocation.department}
  </span>
        <span className="font-semibold">
         {allocation.percentage.toFixed(1)}%
   </span>
            </div>
  ))}
        </div>
       </div>
                )}
      </div>
        </div>
   )}

  {/* Manual Overrides */}
          {distribution.hasManualOverride && distribution.manualOverrides && (
            <div className="card">
              <div className="card-header">
             <h3 className="card-title">Manual Adjustments</h3>
         </div>
 <div className="card-body">
    <div className="overflow-x-auto">
    <table className="table">
           <thead>
              <tr>
     <th>Employee</th>
        <th className="text-right">Original Amount</th>
     <th className="text-right">Actual Amount</th>
                   <th className="text-right">Difference</th>
    </tr>
         </thead>
        <tbody>
       {distribution.manualOverrides.map((override, index) => {
        const employee = distribution.allocations.find(
            (a) => a.employeeId === override.employeeId
      );
   return (
         <tr key={index}>
           <td>{employee?.employeeName || "Unknown"}</td>
      <td className="text-right">
          {formatAmount(override.originalAmount)}
    </td>
       <td className="text-right font-semibold">
               {formatAmount(override.actualAmount)}
   </td>
             <td
          className={`text-right font-semibold ${
           override.difference > 0
    ? "text-success"
        : override.difference < 0
           ? "text-destructive"
    : ""
              }`}
          >
     {override.difference > 0 ? "+" : ""}
          {formatAmount(override.difference)}
         </td>
     </tr>
      );
        })}
                    </tbody>
              </table>
           </div>
      </div>
            </div>
       )}

  {/* Employee Allocations */}
          <div className="card">
          <div className="card-header">
      <h3 className="card-title">Employee Allocations</h3>
  </div>
     <div className="card-body">
       <div className="overflow-x-auto">
        <table className="table">
        <thead>
          <tr>
      <th>Employee</th>
  <th>Job Role</th>
          <th className="text-right">Percentage</th>
 <th className="text-right">Amount</th>
           {distribution.allocations.some((a) => a.hoursWorked) && (
         <th className="text-right">Hours Worked</th>
       )}
      </tr>
         </thead>
 <tbody>
         {distribution.allocations.map((allocation) => (
         <tr key={allocation.employeeId}>
           <td>
                <div className="flex items-center gap-2">
      <div className="w-8 h-8 rounded-full bg-primary/10 flex items-center justify-center">
     <Icon name="User" size={16} className="text-primary" />
      </div>
<span className="font-medium">
        {allocation.employeeName}
     </span>
  </div>
      </td>
             <td>
 <span className="badge badge-secondary">
           {allocation.jobRoleName || "N/A"}
               </span>
   </td>
     <td className="text-right">
      {allocation.percentage.toFixed(2)}%
            </td>
    <td className="text-right font-semibold text-primary">
         {formatAmount(allocation.amount)}
          </td>
        {distribution.allocations.some((a) => a.hoursWorked) && (
          <td className="text-right">
{allocation.hoursWorked?.toFixed(1) || "-"}
  </td>
       )}
    </tr>
   ))}
        </tbody>
     <tfoot>
    <tr className="font-bold">
     <td colSpan={distribution.allocations.some((a) => a.hoursWorked) ? 3 : 2}>
              Total
                </td>
     <td className="text-right text-primary">
       {formatAmount(
 distribution.allocations.reduce(
            (sum, a) => sum + a.amount,
       0
       )
       )}
          </td>
           {distribution.allocations.some((a) => a.hoursWorked) && (
   <td></td>
 )}
          </tr>
      </tfoot>
        </table>
         </div>
  </div>
          </div>

  {/* Notes */}
       {distribution.notes && (
            <div className="card">
              <div className="card-header">
          <h3 className="card-title">Notes</h3>
              </div>
              <div className="card-body">
    <p className="text-sm whitespace-pre-wrap">{distribution.notes}</p>
           </div>
 </div>
  )}
        </div>

  <div className="modal-footer">
     <button onClick={onClose} className="btn btn-secondary">
            <Icon name="X" size={16} />
        Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default DistributionDetailModal;
